/* AUTO-GENERATED by `npm run i18n` — do not edit by hand.
 * English → Filipino (Tagalog) UI translations. Edit English in the components,
 * or put manual corrections in overrides.fil.ts (those always win). */

export const AUTO_FIL: Record<string, string> = {
  " — it is never pushed into a bid. Davis-Bacon is project-specific (by WD number) and isn’t auto-pulled.": " — hindi ito kailanman ipinapasok sa isang bid. Ang Davis-Bacon ay project-specific (kada WD number) at hindi auto-pulled.",
  " (8+ characters)": " (8+ na karakter)",
  " (auto-advanced to the new determination ✓)": " (auto na inilipat sa bagong determination ✓)",
  " You can raise a rate but not set it below the company default.": " Pwede mong itaas ang rate pero hindi pwedeng mas mababa sa company default.",
  "— change a role or remove access when someone leaves (takes effect immediately)": "— baguhin ang role o alisin ang access kapag may umalis (agad na magkakabisa)",
  "— enter actuals": "— ilagay ang actuals",
  "— estimate vs actual (after the job is built)": "— estimate vs actual (pagkatapos maitayo ang job)",
  "— final number only; no internal breakdown": "— final number lamang; walang internal breakdown",
  "— full house-format document: cover, scope & bill of materials, investment summary, terms, acceptance. Opens in Microsoft Word.": "— full house-format document: cover, scope & bill of materials, investment summary, terms, acceptance. Bubukas sa Microsoft Word.",
  "— historical part pricing used by BOM repricing": "— historical part pricing na ginagamit ng BOM repricing",
  "— how our bid compared to the winning number on losses": "— kung paano ang bid natin kumpara sa winning number sa mga losses",
  "— learn real productivity from completed jobs; tunes labor hours on every bid": "— natututo ng totoong productivity mula sa mga tapos na trabaho; ina-adjust ang labor hours sa bawat bid",
  "— let estimators & salespeople create their own accounts": "— hayaang gumawa ng sariling account ang mga estimator at salesperson",
  "— only those go to the AI (fast, accurate, lower cost).": "— iyon lang ang mapupunta sa AI (mabilis, tumpak, mas mura).",
  "— prevailing wage & Davis-Bacon by county; used by the cost engine": "— prevailing wage at Davis-Bacon kada county; ginagamit ng cost engine",
  "— proposals assemble from these blocks; the software invents nothing": "— ang mga proposal ay binubuo mula sa mga block na ito; walang iniimbento ang software",
  "— pulls current rates from the official DIR determinations": "— kinukuha ang kasalukuyang rates mula sa opisyal na DIR determinations",
  "— seed every new bid AND set the floor estimators can't go below": "— seed every new bid AND set the floor estimators can't go below",
  "— select device —": "— pumili ng device —",
  "— the #1 way to lose money is forgetting scope": "— ang #1 dahilan ng pagkalugi ay ang nakalimutang scope",
  "— verify each against the current official CA DIR / DOL determination for the project county before bidding. Editing a rate marks it confirmed.": "— i-verify ang bawat isa laban sa kasalukuyang opisyal na CA DIR / DOL determination para sa county ng proyekto bago mag-bid. Ang pag-edit ng rate ay nagmamarka nito bilang confirmed.",
  ": enter the Division 27 and 28 pages, e.g.": ": ilagay ang mga pahina ng Division 27 at 28, hal.",
  ": open your PDF and find the T-drawings (legend, notes, schedules, riser); enter their page numbers like": ": buksan ang iyong PDF at hanapin ang T-drawings (legend, notes, schedules, riser); ilagay ang kanilang page numbers tulad ng",
  "· pending": "· nakabinbin",
  "(you)": "(ikaw)",
  "↻ Update CA prevailing wages now": "↻ I-update ang CA prevailing wages ngayon",
  "+ Add": "+ Idagdag",
  "+ Add rate": "+ Magdagdag ng rate",
  "+ New Bid": "+ Bagong Bid",
  "+ Record actuals": "+ I-record ang actuals",
  "✓ Saved to bids": "✓ Na-save sa bids",
  "💾 Save as bid": "💾 I-save bilang bid",
  "💾 Update saved bid": "💾 I-update ang naka-save na bid",
  "5 = clear scope, no site/wage surprises": "5 = malinaw ang scope, walang sorpresa sa site/wage",
  "5 = few bidders, we are favored": "5 = kaunti ang bidders, paborito tayo",
  "5 = we can comfortably staff it": "5 = kaya nating i-staff nang komportable",
  "A friendly, step-by-step walkthrough of The AI Solution for 3D. Take your time — you can read it anytime.": "Isang madaling sundan na gabay para sa The AI Solution for 3D. Huwag magmadali — puwede mo itong basahin kahit kailan.",
  "Accept the AI's device suggestion for every row that has one. Rows with no suggested device still need manual assignment.": "Accept the AI's device suggestion for every row that has one. Rows with no suggested device still need manual assignment.",
  "accepted — resolve the flags below, then re-import.": "ang tinanggap — ayusin ang mga flag sa baba, tapos i-import ulit.",
  "Accessible attic spaces (adds heat detectors per story)": "May accessible na attic spaces (nagdadagdag ng heat detectors kada story)",
  "Account created — an admin must approve it before you can sign in.": "Nagawa na ang account — kailangan munang aprubahan ito ng Admin bago ka makakapag-sign in.",
  "Actions": "Mga Aksyon",
  "Active": "Aktibo",
  "actual": "actual",
  "Actual": "Actual",
  "Actual margin": "Actual margin",
  "Add": "Magdagdag",
  "Add a closed job (est / actual)": "Magdagdag ng saradong trabaho (est / actual)",
  "Add failed": "Nabigo ang pagdagdag",
  "Add failed (admin only)": "Nabigo ang pagdagdag (admin lang)",
  "Adding…": "Idinadagdag…",
  "Adjust pricing before you send.": "I-adjust ang pricing bago mo ipadala.",
  "Admin Settings": "Mga Setting ng Admin",
  "After a job closes, enter the": "Pagkatapos magsara ng trabaho, ilagay ang",
  "After the job is built: real numbers": "Pagkatapos ng trabaho: totoong mga numero",
  "AI reads, humans count": "Nagbabasa ang AI, nagbibilang ang tao",
  "AI reads. Humans count.": "Nagbabasa ang AI. Nagbibilang ang tao.",
  "AI upload failed": "Nabigo ang AI upload",
  "All": "Lahat",
  "All bids": "Lahat ng bid",
  "All bids (shared — anyone can open and work on these)": "Lahat ng bid (shared — kahit sino puwedeng magbukas at magtrabaho dito)",
  "all time": "lahat ng panahon",
  "Allowances / Exclusions": "Mga Allowance / Exclusion",
  "Already have an account?": "May account ka na?",
  "already have counts (they round-trip).": "ang may count na (mababalik sila).",
  "Alternates": "Mga Alternate",
  "An admin reset your password. Please choose a new one to continue.": "Ni-reset ng isang Admin ang iyong password. Pumili ng bago para magpatuloy.",
  "Analysis complete —": "Tapos na ang pagsusuri —",
  "Analysis complete.": "Tapos na ang pagsusuri.",
  "Analysis complete. (Automatic symbol-image cropping failed — you can run it manually from the Count Sheet.)": "Tapos na ang pagsusuri. (Nabigo ang awtomatikong pagkuha ng symbol image — maaari mong patakbuhin ito nang manu-mano mula sa Count Sheet.)",
  "Analysis complete. Symbol images could not be cropped automatically — open “Get Symbol Images from Legend” to try a specific page.": "Tapos na ang pagsusuri. Hindi awtomatikong nakuha ang mga symbol image — buksan ang “Get Symbol Images from Legend” para subukan ang isang partikular na pahina.",
  "Analyze documents": "Suriin ang mga dokumento",
  "Analyze documents first": "I-analyze muna ang mga dokumento",
  "Analyze the plan documents first, then count and map them.": "I-analyze muna ang mga plan document, tapos bilangin at i-map ang mga ito.",
  "Analyzing": "Sinusuri ang",
  "Analyzing…": "Sinusuri…",
  "Appears on your Dashboard · reopen anytime": "Lalabas sa iyong Dashboard · mabubuksan anumang oras",
  "applied": "inilapat",
  "Applies to": "Saklaw",
  "Apply": "Ilapat",
  "Apprentice rate (% of JW)": "Apprentice rate (% of JW)",
  "Apprentice ratio (0–0.6)": "Apprentice ratio (0–0.6)",
  "Approve": "Aprubahan",
  "Approve failed": "Nabigo ang pag-approve",
  "Architect": "Architect",
  "Authoritative reference for fire alarm and Division 27/28 work. Use it on bids, in proposals, and for AHJ submittal references.": "Authoritative reference para sa fire alarm at Division 27/28 na trabaho. Gamitin ito sa mga bid, sa mga proposal, at para sa AHJ submittal references.",
  "auto-filled from the documents; edit or confirm each field": "awtomatikong napuno mula sa mga dokumento; i-edit o kumpirmahin ang bawat field",
  "Auto-filters: rows with HR/LS units (labor / lump-sum), unit price < $0.10 (placeholders), or no part_number AND no manufacturer are skipped.": "Auto-filters: nila-laktawan ang rows na may HR/LS units (labor / lump-sum), unit price < $0.10 (placeholders), o walang part_number AT walang manufacturer.",
  "awaiting outcome": "hinihintay ang resulta",
  "Back": "Bumalik",
  "Back to project": "Bumalik sa project",
  "Basis": "Basis",
  "below the company rate isn't allowed — kept at the default.": "below the company rate isn't allowed — kept at the default.",
  "Bid / No-Bid scorecard": "Bid / No-Bid scorecard",
  "Bid date": "Bid date",
  "Bid due date": "Takdang petsa ng bid",
  "Bid ready — sell price": "Handa na ang bid — sell price",
  "bid-day strategy, who to call, deal-breakers…": "strategy sa bid-day, sino tatawagan, mga deal-breaker…",
  "Bid/No-Bid recommendation": "Bid/No-Bid recommendation",
  "Bids you estimate": "Mga bid na ine-estimate mo",
  "Bids you sell": "Mga bid na binebenta mo",
  "Bill of materials": "Bill of materials",
  "BOM generation failed": "Nabigo ang pag-generate ng BOM",
  "BOM generation is blocked until every symbol is resolved.": "Naka-block ang BOM generation hangga't hindi pa naa-resolve ang bawat symbol.",
  "BOM line item": "BOM line item",
  "Budgetary ROM only — not a stamped design. Final design by licensed FA engineer; AHJ submittal required.": "Budgetary ROM lang — hindi ito stamped design. Ang final design ay gagawin ng licensed FA engineer; kailangan ng AHJ submittal.",
  "Building gross SF": "Building gross SF",
  "Building size + telecom-room count set the average cable run length (vs. a flat 140 ft allowance). Labor factor > 1.0 for tough conditions (high ceilings, occupied/live site, escorted access); < 1.0 for easy open-construction. Crew mix blends in lower-cost apprentice hours.": "Ang building size + bilang ng telecom-room ang nagtatakda ng average cable run length (kumpara sa flat na 140 ft allowance). Labor factor > 1.0 para sa mahihirap na kondisyon (high ceilings, occupied/live site, escorted access); < 1.0 para sa madaling open-construction. Ang crew mix ay nagsasama ng mas mababang-gastos na apprentice hours.",
  "Bulk-import CSV (procore export or sp_static)": "Bulk-import CSV (procore export o sp_static)",
  "bundled sample extraction": "kasamang sample extraction",
  "Burden": "Burden",
  "By source:": "Ayon sa source:",
  "Cable waste %": "Cable waste %",
  "Calculate Design": "Calculate Design",
  "CALCULATE DESIGN": "KALKULAHIN ANG DESIGN",
  "Calibrated from 3DTSI’s won bids (~30% gross margin). Every new bid starts from these, and they are the floor — estimators can raise a markup but not go below it (sales tax excepted, since it varies by county). Changing a default only affects NEW bids.": "Naka-calibrate mula sa mga napanalunang bid ng 3DTSI (~30% gross margin). Dito nagsisimula ang bawat bagong bid, at ito ang floor — puwedeng itaas ng estimator ang markup pero hindi puwedeng babaan ito (maliban sa sales tax, dahil iba-iba kada county). Ang pagbabago ng default ay sa BAGONG bid lang nakakaapekto.",
  "California Fire Alarm Design-Build wizard (Budgetary ROM only — not a stamped design)": "California Fire Alarm Design-Build wizard (Budgetary ROM lang — hindi stamped design)",
  "Cancel": "Kanselahin",
  "Cascades each counted symbol → confirmed device → assembly parts. Material is internet-estimated until distributor pricing (Phase 6); labor is NECA MLU / BICSI hours.": "Kina-cascade ang bawat counted symbol → confirmed device → assembly parts. Internet-estimated ang material hanggang sa distributor pricing (Phase 6); ang labor ay NECA MLU / BICSI hours.",
  "Category": "Kategorya",
  "Change password": "Palitan ang password",
  "Checking the symbols (very important)": "Pagtsek ng mga simbolo (napakahalaga)",
  "Choose documents, set type & pages, then Analyze": "Pumili ng mga dokumento, itakda ang type at pages, tapos Analyze",
  "Choose one or more PDFs first (spec and/or plans).": "Pumili muna ng isa o higit pang PDF (spec at/o plans).",
  "Choose the plan PDF first.": "Piliin muna ang plan PDF.",
  "Classification": "Classification",
  "Clean import.": "Malinis na import.",
  "Clear accumulated data": "Burahin ang naipong data",
  "click Choose Files and upload again": "i-click ang Choose Files at mag-upload muli",
  "click your job type to add the right labor hours (badging, escorts, flagging, ICRA…)": "i-click ang job type mo para maidagdag ang tamang labor hours (badging, escorts, flagging, ICRA…)",
  "Close": "Isara",
  "CLOSED": "SARADO",
  "Codes & standards": "Codes at standards",
  "Codes & Standards": "Codes at Standards",
  "Codes & Standards Library": "Codes & Standards Library",
  "Company content comes from the editable Company Profile (Admin) — the software invents no company facts. The proposal shows material quantities and a category-level investment summary; it never exposes unit pricing, markup or profit.": "Ang company content ay galing sa editable na Company Profile (Admin) — walang ini-imbentong company facts ang software. Ipinapakita ng proposal ang material quantities at category-level na investment summary; hindi nito kailanman inilalantad ang unit pricing, markup o profit.",
  "Company default $/hr": "Company default $/hr",
  "Company Profile, personnel and the codes library. Only admins can edit.": "Company Profile, personnel at ang codes library. Admin lang ang puwedeng mag-edit.",
  "Competitive position": "Posisyon sa kompetisyon",
  "Competitor (optional)": "Competitor (opsyonal)",
  "Completed date": "Petsa ng pagkatapos",
  "Conf.": "Conf.",
  "confidence": "confidence",
  "Confidence": "Confidence",
  "Confirm": "Kumpirmahin",
  "Confirm new password": "Kumpirmahin ang bagong password",
  "Confirm-all failed": "Nabigo ang confirm-all",
  "confirmed": "confirmed",
  "Conflicts & ambiguities": "Mga Conflict at ambiguity",
  "Continue": "Magpatuloy",
  "Continue to Bid & Proposal →": "Magpatuloy sa Bid & Proposal →",
  "Continue to Count Sheet": "Magpatuloy sa Count Sheet",
  "Cost summary": "Cost summary",
  "Could not add (admin only).": "Hindi naidagdag (admin lang).",
  "Could not change password": "Hindi mapalitan ang password",
  "Could not read PDF": "Hindi mabasa ang PDF",
  "Could not upload any documents to the AI.": "Walang dokumentong na-upload sa AI.",
  "Count Sheet": "Count Sheet",
  "counties": "counties",
  "Counting symbols — the Take-off": "Pagbilang ng mga simbolo — ang Take-off",
  "County": "County",
  "County / State": "County / State",
  "covered": "sakop",
  "Create": "Gumawa",
  "Create a bid": "Gumawa ng bid",
  "Create account & continue": "Gumawa ng account at magpatuloy",
  "Create admin & continue": "Gumawa ng Admin at magpatuloy",
  "Create admin account": "Gumawa ng admin account",
  "Create an account": "Gumawa ng account",
  "Create bid": "Gumawa ng bid",
  "Create the project workspace. After this, you'll upload documents — the AI reads them, you count.": "Create the project workspace. After this, you'll upload documents — the AI reads them, you count.",
  "Create your account": "Gumawa ng iyong account",
  "Create your first bid to begin. The AI reads the documents; your estimators do all counting.": "Gumawa ng unang bid mo para magsimula. Binabasa ng AI ang mga documents; ang mga estimator mo ang gagawa ng lahat ng counting.",
  "Creating…": "Ginagawa…",
  "Crew blend (effective)": "Crew blend (effective)",
  "Cropping symbol images from the legend": "Kinukuha ang mga symbol image mula sa legend",
  "Cropping symbols…": "Kinukuha ang mga symbol…",
  "Current password": "Kasalukuyang password",
  "Current QTY": "Kasalukuyang QTY",
  "Currently": "Kasalukuyang",
  "Customer": "Customer",
  "Customer / Owner": "Customer / Owner",
  "Dashboard": "Dashboard",
  "Date": "Petsa",
  "Davis-Bacon applies (yes/no)": "May Davis-Bacon (oo/hindi)",
  "Decided bids": "Decided na bid",
  "default": "default",
  "Default markups & margins": "Default markups at margins",
  "Delete": "Burahin",
  "Delete bid": "Burahin ang bid",
  "Delete every row (re-import to restore)": "Burahin ang bawat row (i-import muli para ibalik)",
  "Delete failed": "Hindi nabura",
  "Description": "Paglalarawan",
  "Details": "Mga Detalye",
  "Detected": "Natukoy",
  "Detected by the AI": "Natukoy ng AI",
  "Did we win or lose? (very important!)": "Nanalo ba tayo o natalo? (napakahalaga!)",
  "DIR period": "DIR period",
  "Direct cost": "Direct cost",
  "Discipline": "Disiplina",
  "Disciplines the AI detected (•) are pre-selected — click any chip to add or remove. Only selected disciplines flow into the count sheet, BOM and estimate.": "Ang mga discipline na natukoy ng AI (•) ay paunang napili — i-click ang anumang chip para magdagdag o mag-alis. Tanging napiling mga discipline lang ang dadaloy sa count sheet, BOM at estimate.",
  "Div 27/28, e.g. 220-260": "Div 27/28, hal. 220-260",
  "document(s) — reading every page (legend, symbols, notes, systems)…": "na dokumento — binabasa ang bawat pahina (legend, symbols, notes, systems)…",
  "Documents (spec, plans, addenda)": "Mga Dokumento (spec, plans, addenda)",
  "Documents:": "Mga Dokumento:",
  "Download": "I-download",
  "Download Proposal (PDF)": "I-download ang Proposal (PDF)",
  "Drop the completed": "I-drop ang kumpletong",
  "Duplicate symbols": "Dobleng symbols",
  "e.g. 154000": "hal. 154000",
  "e.g. 50000": "hal. 50000",
  "e.g. Clark": "hal. Clark",
  "Edit": "I-edit",
  "Edit outcome": "I-edit ang resulta",
  "edited": "na-edit",
  "Email": "Email",
  "email, and only as an Estimator or Salesperson (never admin). New sign-ups are": "email, at bilang Estimator o Salesperson lang (hindi admin). Ang mga bagong sign-up ay",
  "Engineer": "Engineer",
  "entries": "mga entry",
  "Error": "May error",
  "errors": "errors",
  "est.": "est.",
  "Estimate": "Estimate",
  "Estimate & documents": "Estimate & mga dokumento",
  "estimated": "estimated",
  "Estimated": "Estimated",
  "Estimated margin": "Estimated margin",
  "Estimator": "Estimator",
  "Estimators can raise the labor factor but not drop it below the facility-type default. On prevailing-wage jobs honor the published apprentice rates & ratio limits. Changes apply on the next bid generation.": "Pwedeng itaas ng estimators ang labor factor pero hindi ibaba sa facility-type default. Sa prevailing-wage na trabaho, sundin ang published apprentice rates at ratio limits. Maaaplay ang mga pagbabago sa susunod na bid generation.",
  "Every counted symbol must be matched to a device before the BOM can cascade.": "Bawat counted symbol ay dapat ma-match sa isang device bago mag-cascade ang BOM.",
  "Exclude": "I-exclude",
  "excluded": "excluded",
  "Export": "I-export",
  "Export CSV": "I-export ang CSV",
  "Export PE-ready Submittal Package (Word)": "I-export ang PE-ready Submittal Package (Word)",
  "Extracting requested pages from": "Kinukuha ang mga hiniling na pahina mula sa",
  "Extracting…": "Ine-extract…",
  "Extraction failed": "Nabigo ang extraction",
  "Factor": "Factor",
  "fail": "bagsak",
  "Failed to create project": "Hindi nagawa ang project",
  "Failed to load": "Hindi ma-load",
  "Failed to load BOM": "Hindi na-load ang BOM",
  "Failed to load calibration": "Hindi ma-load ang calibration",
  "Failed to load codes": "Hindi na-load ang mga codes",
  "Failed to load mappings": "Hindi na-load ang mga mapping",
  "Failed to load pending users": "Hindi ma-load ang pending users",
  "Failed to load rates": "Hindi ma-load ang rates",
  "Failed to load symbols": "Hindi na-load ang mga symbol",
  "Failed to load users": "Hindi ma-load ang users",
  "Failed to load wage rates": "Hindi ma-load ang wage rates",
  "feed Phase 10 RFIs": "pakain sa Phase 10 RFIs",
  "Fetches the current CA DIR General Prevailing Wage Determinations for each county in the library and updates the low-voltage classifications (Sound & Comm Installer, LV Technician, Inside Wireman).": "Kinukuha ang kasalukuyang CA DIR General Prevailing Wage Determinations para sa bawat county sa library at ina-update ang low-voltage classifications (Sound & Comm Installer, LV Technician, Inside Wireman).",
  "Fetching from DIR…": "Kinukuha mula sa DIR…",
  "Field": "Field",
  "field hours for each trade. The factor (Σ actual ÷ Σ estimated) then tunes labor hours on every future bid. Empty = 1.0 (no change) until you add real data.": "field hours para sa bawat trade. Ang factor (Σ actual ÷ Σ estimated) ay ina-adjust ang labor hours sa bawat susunod na bid. Walang laman = 1.0 (walang pagbabago) hanggang magdagdag ka ng totoong data.",
  "File": "File",
  "Fill in the inputs on the left and click": "Punan ang mga input sa kaliwa at i-click ang",
  "Fire Alarm Design-Build estimate": "Fire Alarm Design-Build estimate",
  "First run — set up the administrator for The AI Solution.": "Unang takbo — i-set up ang administrator para sa The AI Solution.",
  "flagged": "na may flag na",
  "Floors": "Floors",
  "Folder": "Folder",
  "for all references attached to a proposal.": "para sa lahat ng references na nakakabit sa isang proposal.",
  "For each file pick what it is.": "Para sa bawat file, piliin kung ano ito.",
  "For the": "Para sa",
  "For the boss (Admin only)": "Para sa boss (Admin lang)",
  "Forecasted margin": "Forecasted margin",
  "Forecasted profit (markup + profit)": "Forecasted profit (markup + profit)",
  "from memory": "mula sa memory",
  "Full material, labor and source detail. This is never shown to customers — proposals carry the final number alone. Quantities came from your count sheet; the software never counts.": "Kompletong material, labor at source detail. Hindi ito ipinapakita sa mga customer — ang final na numero lang ang nasa proposals. Galing sa iyong count sheet ang quantities; hindi nagbibilang ang software.",
  "Full name": "Buong pangalan",
  "full PDF": "buong PDF",
  "GC contact": "GC contact",
  "General Contractor": "General Contractor",
  "Generate": "Mag-generate",
  "Generate Bid →": "I-generate ang Bid →",
  "Generate BOM": "I-generate ang BOM",
  "Generate from counts": "I-generate mula sa counts",
  "Generate RFIs": "Mag-generate ng RFIs",
  "Generate Symbol Quantity Excel": "I-generate ang Symbol Quantity Excel",
  "Generate the bid": "I-generate ang bid",
  "Generate the branded Symbol Quantity Excel, enter quantities by hand, then drop it back.": "I-generate ang branded na Symbol Quantity Excel, i-type nang manu-mano ang mga quantity, tapos i-drop ulit dito.",
  "Generate the Symbol Quantity Excel": "Buuin ang Symbol Quantity Excel",
  "Generating…": "Nire-generate…",
  "Get Symbol Images from Legend": "Kunin ang Symbol Images mula sa Legend",
  "Go to Dashboard": "Pumunta sa Dashboard",
  "Go to Scope Analysis →": "Pumunta sa Scope Analysis →",
  "Google’s models were busy.": "Abala ang mga model ng Google.",
  "held for review": "held para suriin",
  "Help": "Tulong",
  "Helper tools": "Mga tools na pantulong",
  "here, or click to choose. Press": "dito, o i-click para pumili. Pindutin ang",
  "Hierarchy: approved quote → distributor → admin DB → internet → historical. Upload a distributor price list or supplier quote, then reprice.": "Hierarchy: approved quote → distributor → admin DB → internet → historical. Mag-upload ng distributor price list o supplier quote, tapos i-reprice.",
  "Hours": "Oras",
  "hrs": "hrs",
  "hrs.": "hrs.",
  "Import completed sheet": "I-import ang kumpletong sheet",
  "Import failed": "Nabigo ang import",
  "Import validation report": "Import validation report",
  "Imported rates auto-apply on the next": "Ang mga na-import na rate ay automatic na inilalapat sa susunod na",
  "Imported with issues.": "Na-import pero may isyu.",
  "in a minute — it usually goes through on a second try. A single legend sheet reads most reliably.": "pagkalipas ng isang minuto — kadalasan ay tumatagos ito sa pangalawang subok. Ang isang legend sheet ang pinakamatibay na nababasa.",
  "in scope (selected systems, excluding mapping-excluded).": "na nasa scope (mga piniling systems, hindi kasama ang mapping-excluded).",
  "Industry / facility type": "Industry / facility type",
  "Ingest failed": "Nabigo ang ingest",
  "Internal BOM": "Internal BOM",
  "Internal Estimate (PDF)": "Internal Estimate (PDF)",
  "Internal only.": "Internal lang.",
  "It maps types; it never counts.": "Tina-type lang nito; hindi ito nagbibilang.",
  "Job address": "Job address",
  "Job closeout": "Job closeout",
  "Jobs": "Trabaho",
  "labor": "labor",
  "Labor": "Labor",
  "Labor & wage basis": "Labor at wage basis",
  "Labor $": "Labor $",
  "Labor cost": "Labor cost",
  "Labor factor (productivity)": "Labor factor (productivity)",
  "Labor hours": "Labor hours",
  "Labor rates — this bid": "Labor rates — ang bid na ito",
  "Learns from the outcomes you record on the Dashboard. The more bids you mark Won/Lost, the sharper this gets.": "Natututo mula sa mga outcome na ni-record mo sa Dashboard. Habang mas maraming bid ang mina-mark mong Won/Lost, mas tumatalas ito.",
  "Leave blank or type": "Iwanang blangko o i-type ang",
  "Legend description": "Legend description",
  "Lessons learned (optional)": "Lessons learned (opsyonal)",
  "Letting the AI read the plans": "Hayaang basahin ng AI ang mga plano",
  "Level": "Antas",
  "likely missing": "malamang kulang",
  "line items.": "line items.",
  "lines": "lines",
  "Loaded straight-time rate (base + burden + fringe). Shift and crew-mix multipliers still apply on top. Leave a box blank to use the company default.": "Loaded straight-time rate (base + burden + fringe). Naka-apply pa rin sa ibabaw ang shift at crew-mix multipliers. Iwanang blangko ang isang box para gamitin ang company default.",
  "Loading analytics…": "Naglo-load ng analytics…",
  "Loading projects…": "Naglo-load ng mga project…",
  "Loading…": "Naglo-load…",
  "Lost": "Lost",
  "Low risk": "Mababang risk",
  "Making the bid (the parts list)": "Paggawa ng bid (ang listahan ng parts)",
  "Margin = (material markup + profit) ÷ sell price. Adjust the Material markup and Profit rows above to hit your target margin.": "Margin = (material markup + profit) ÷ sell price. I-adjust ang Material markup at Profit rows sa itaas para abutin ang target margin mo.",
  "Margin potential": "Margin potential",
  "Markup / margin": "Markup / margin",
  "matched by hidden Row ID (never by position).": "tinugma gamit ang hidden Row ID (hindi base sa posisyon).",
  "material": "material",
  "Material": "Material",
  "material + labor": "material + labor",
  "Material pricing": "Material pricing",
  "Min": "Min",
  "Missing / blank quantities": "Kulang / blankong quantities",
  "My bids": "Mga bid ko",
  "My sales": "Mga benta ko",
  "Name": "Pangalan",
  "need review": "kailangang i-review",
  "Needs a part/price (no assembly yet — review)": "Kailangan ng part/price (wala pang assembly — i-review)",
  "needs mapping": "kailangan ng mapping",
  "needs review": "kailangang i-review",
  "Negative quantities": "Negatibong quantities",
  "New 3DTSI employee?": "Bagong empleyado ng 3DTSI?",
  "New Bid": "Bagong Bid",
  "New password (at least 8 characters)": "Bagong password (hindi bababa sa 8 character)",
  "New password must be at least 8 characters.": "Ang bagong password ay dapat hindi bababa sa 8 character.",
  "Next": "Susunod",
  "No": "Hindi",
  "No bids assigned to you yet": "Wala pang bid na naka-assign sa iyo",
  "No bids list you as salesperson yet": "Wala pang bid na nakalista sa iyo bilang salesperson",
  "No bids yet": "Wala pang bid",
  "No BOM yet — generate it first.": "Wala pang BOM — i-generate muna ito.",
  "No BOM yet. Resolve mappings, import counts, then Generate BOM.": "Wala pang BOM. Ayusin ang mappings, i-import ang counts, tapos I-generate ang BOM.",
  "No catalog assembly:": "Walang catalog assembly:",
  "No change-order risks yet. Generate from alternates, allowances and scope flags.": "Wala pang change-order risks. Mag-generate mula sa alternates, allowances at scope flags.",
  "No confirmed devices yet — confirm scope and generate the BOM.": "Wala pang confirmed devices — i-confirm ang scope at i-generate ang BOM.",
  "no decided bids yet": "wala pang na-desisyunan na bid",
  "No decided bids yet": "Wala pang decided na bid",
  "No decided bids yet.": "Wala pang decided na bid.",
  "No Gemini key configured — used the": "Walang naka-configure na Gemini key — ginamit ang",
  "No legend symbols were read yet — point Step 1 at the legend sheet (e.g. the": "Wala pang nabasang legend symbols — ituro ang Step 1 sa legend sheet (hal. ang",
  "No results": "Walang resulta",
  "No RFIs yet. Generate from the analysis flags.": "Wala pang RFIs. Mag-generate mula sa analysis flags.",
  "No symbols on this project yet — run Analyze first.": "Wala pang symbols sa project na ito — i-run muna ang Analyze.",
  "No symbols yet — analyze the plan documents first.": "Wala pang symbols — i-analyze muna ang plan documents.",
  "No symbols yet.": "Wala pang symbols.",
  "No symbols yet. Upload and analyze a plan set first.": "Wala pang symbol. Mag-upload at mag-analyze muna ng plan set.",
  "No users exist yet. The account you create now becomes the Admin.": "Wala pang users. Ang account na gagawin mo ngayon ang magiging Admin.",
  "No users yet.": "Wala pang users.",
  "No-bid": "No-bid",
  "Non-numeric quantities": "Hindi-numero na quantities",
  "none": "wala",
  "None flagged.": "Walang na-flag.",
  "None yet.": "Wala pa.",
  "Not detected — click to add to this bid": "Hindi natukoy — i-click para idagdag sa bid na ito",
  "Not in this scope": "Wala sa scope na ito",
  "Notes": "Mga Tala",
  "Notes (optional)": "Mga tala (opsyonal)",
  "of": "sa",
  "On": "Sa",
  "on lost bids (Outcome → \"winning bid $\") to see how far above the market we were.": "sa mga lost na bid (Outcome → \"winning bid $\") para makita kung gaano kalayo tayo sa market.",
  "on your bids (Dashboard → Outcome) and your win rate, competitive pricing gap and per-estimator/customer trends appear here.": "sa iyong mga bid (Dashboard → Outcome) at lalabas dito ang iyong win rate, competitive pricing gap at mga trend per-estimator/customer.",
  "One click does the rest automatically: cascades your counts into the BOM, prices it from your rate library, and computes the estimate. Anything it couldn't price is listed below — never hidden.": "One click does the rest automatically: cascades your counts into the BOM, prices it from your rate library, and computes the estimate. Anything it couldn't price is listed below — never hidden.",
  "Open": "Buksan",
  "OPEN": "BUKAS",
  "Open (clear)": "Open (i-clear)",
  "Open / bidding": "Open / bidding",
  "Open Legend Layout →": "Buksan ang Legend Layout →",
  "Open your PDF and find the \"Symbols, Legends and Abbreviations\" sheet (often the first T-sheet).": "Buksan ang iyong PDF at hanapin ang \"Symbols, Legends and Abbreviations\" sheet (madalas ang unang T-sheet).",
  "Optional": "Opsyonal",
  "or": "o",
  "or symbols-legend page), or proceed and add them on the count sheet.": "o symbols-legend page), o magpatuloy at idagdag ang mga ito sa count sheet.",
  "Other / change orders": "Iba pa / change orders",
  "Our bid": "Our bid",
  "Our Div 27/28 wheelhouse, size & type": "Ang Div 27/28 wheelhouse natin, laki at type",
  "Our winning bid $ (optional)": "Ang panalo nating bid $ (opsyonal)",
  "Outcome": "Resulta",
  "Outputs: RFIs, PDFs, estimate →": "Outputs: RFIs, PDFs, estimate →",
  "Over/under": "Over/under",
  "Owner-furnished, contractor-installed (we install; owner buys the device)": "Owner-furnished, contractor-installed (kami ang nag-i-install; owner ang bumibili ng device)",
  "Owner-furnished, contractor-installed: we install it but the owner buys the device": "Owner-furnished, contractor-installed: kami ang nag-i-install pero ang owner ang bumibili ng device",
  "pages": "na pahina",
  "Pages to read": "Mga pahinang babasahin",
  "pass": "pasado",
  "passed on": "di tinuloy",
  "Password": "Password",
  "pending": "pending",
  "Per unit": "Kada unit",
  "Picking a type sets the Labor factor below; you can still fine-tune it. These factors follow standard estimating practice (NECA labor-unit adjustments + MCAA labor factors) — secured/occupied/operational sites take more hours for the same install.": "Ang pagpili ng type ang magse-set ng Labor factor sa baba; pwede mo pa ring i-fine-tune. Sinusunod ng mga factor na ito ang standard estimating practice (NECA labor-unit adjustments + MCAA labor factors) — ang secured/occupied/operational na sites ay nangangailangan ng mas maraming oras para sa parehong install.",
  "Pipeline:": "Pipeline:",
  "placeholder": "placeholder",
  "Plans PDF": "Plans PDF",
  "Please wait…": "Sandali lang…",
  "Potential change orders": "Mga posibleng change order",
  "Pre-loaded prevailing-wage / Davis-Bacon rates are": "Ang naka-pre-load na prevailing-wage / Davis-Bacon rates ay",
  "Prevailing-wage jurisdiction": "Prevailing-wage jurisdiction",
  "Price import failed": "Nabigo ang price import",
  "price? scope? schedule?": "presyo? scope? schedule?",
  "Pricing & labor →": "Pricing at labor →",
  "Pricing vs the market": "Pricing vs the market",
  "Pricing, labor & costs": "Pricing, labor at mga gastos",
  "Pricing, labor & margin →": "Pricing, labor & margin →",
  "Pricing, labor and profit": "Presyo, labor, at tubo (profit)",
  "Print": "I-print",
  "Project": "Proyekto",
  "Project address": "Address ng proyekto",
  "Project fit": "Bagay ba ang project",
  "Project information": "Impormasyon ng proyekto",
  "Project Inputs": "Mga Input ng Proyekto",
  "Project name": "Pangalan ng proyekto",
  "Project Name": "Pangalan ng Proyekto",
  "Project name *": "Project name *",
  "Project name is required.": "Kailangan ang project name.",
  "proposed": "proposed",
  "Proposed device type": "Iminungkahing device type",
  "Pursue?": "Ituloy?",
  "QC bid review": "QC bid review",
  "Qty": "Dami",
  "Quantity": "Dami",
  "Quote date": "Quote date",
  "Rate": "Rate",
  "rate each 1 (poor) to 5 (excellent). Score weights fit, margin & relationship most.": "i-rate ang bawat isa mula 1 (mahina) hanggang 5 (napakaganda). Pinakamabigat sa score ang fit, margin at relasyon.",
  "rate(s)": "rate(s)",
  "Rates that pass the sanity checks are applied automatically; anything that looks like a parse error (wild value, >35% jump) is HELD for you to review": "Ang rates na pumasa sa sanity checks ay automatic na inilalapat; anumang mukhang parse error (kakaibang value, >35% jump) ay HELD para suriin mo",
  "rates; edit any rate for this bid only": "rates; i-edit ang anumang rate para sa bid na ito lang",
  "Re-generate the bid to apply.": "I-generate ulit ang bid para ilapat.",
  "Re-propose": "I-re-propose",
  "Re-propose failed": "Nabigo ang re-propose",
  "Re-proposing…": "Nire-propose…",
  "Re-upload the plan PDF. The app reads each symbol's label position straight from the PDF's text layer, then crops the actual symbol from the page. The cropped images are embedded in your Count Sheet's Symbol column.": "I-upload muli ang plan PDF. Binabasa ng app ang label position ng bawat symbol mismo sa text layer ng PDF, tapos kino-crop ang aktwal na symbol mula sa page. Ang mga na-crop na image ay ineembed sa Symbol column ng iyong Count Sheet.",
  "read — not counted": "binasa — hindi binilang",
  "ready for the count sheet.": "handa na para sa count sheet.",
  "Ready to generate the Count Sheet and BOM.": "Handa nang i-generate ang Count Sheet at BOM.",
  "Reason / notes (optional)": "Dahilan / mga tala (opsyonal)",
  "Record": "I-record ang",
  "Record bid outcome": "I-record ang resulta ng bid",
  "Record the": "I-record ang",
  "Refinements (optional — defaults will be calculated)": "Mga Refinement (opsyonal — auto-kakalkulahin ang mga default)",
  "Refresh": "I-refresh",
  "Registered": "Nag-register",
  "Registration OFF": "Registration OFF",
  "Registration ON": "Registration ON",
  "Reject": "Tanggihan",
  "Reject failed": "Nabigo ang pag-reject",
  "Relationship / incumbency": "Relasyon / incumbency",
  "Remember these": "Tandaan ito",
  "Remove": "Alisin",
  "Remove access": "Alisin ang access",
  "Removed": "Inalis",
  "Reprice BOM": "Reprice BOM",
  "Reprice failed": "Nabigo ang reprice",
  "Repricing from the hierarchy…": "Nire-reprice mula sa hierarchy…",
  "Required": "Kailangan",
  "Reset": "I-reset",
  "Reset failed": "Nabigo ang reset",
  "Reset password": "I-reset ang password",
  "Resolve mappings →": "Ayusin ang mappings →",
  "Resolve symbol → device mappings first": "Ayusin muna ang symbol → device mappings",
  "Restore": "Ibalik",
  "Result": "Resulta",
  "Role": "Tungkulin",
  "Room for a healthy margin": "May puwang ba para sa magandang margin",
  "Rows received:": "Rows na natanggap:",
  "Run": "Patakbuhin ang",
  "sample": "sample",
  "Save": "I-save",
  "Save an estimate first — the proposal pulls the investment total and scope from the estimate.": "I-save muna ang estimate — kinukuha ng proposal ang investment total at scope mula sa estimate.",
  "Save changes": "I-save ang mga pagbabago",
  "Save closeout": "I-save ang closeout",
  "Save defaults": "I-save ang defaults",
  "Save failed": "Nabigo ang pag-save",
  "Save failed — try again.": "Nabigo ang pag-save — subukan ulit.",
  "Save failed (admin only)": "Nabigo ang pag-save (admin lang)",
  "Save markups": "I-save ang markups",
  "Save outcome": "I-save ang resulta",
  "Save password": "I-save ang password",
  "Save scorecard": "I-save ang scorecard",
  "saved": "na-save noong",
  "Saved": "Na-save",
  "Saved — new bids start here and estimators can’t bid below these.": "Na-save — dito magsisimula ang mga bagong bid at hindi puwedeng bumaba ang mga estimator sa mga ito.",
  "Saving…": "Sine-save…",
  "scales cable runs to the building & field labor; re-generate the bid to apply": "iniaakma ang cable runs sa building at field labor; i-generate ulit ang bid para ilapat",
  "Schedule capacity": "Kapasidad sa schedule",
  "Scope Analysis": "Scope Analysis",
  "Scope completeness": "Scope completeness",
  "Score": "Score",
  "Search": "Maghanap",
  "Search (code / title / section / notes)": "Maghanap (code / title / section / notes)",
  "Search (part / mfr / description / item)": "Maghanap (part / mfr / description / item)",
  "See the full": "Tingnan ang buong",
  "select all that apply": "piliin lahat ng naaangkop",
  "Sell price": "Sell price",
  "Sell price (preview)": "Sell price (preview)",
  "sell-price preview (the estimate is finalized in Phase 7)": "sell-price preview (ang estimate ay finalize sa Phase 7)",
  "Set a new password": "Magtakda ng bagong password",
  "Settings": "Mga Setting",
  "Shift": "Shift",
  "Should we bid on this job?": "Dapat ba tayong mag-bid dito?",
  "Sign in": "Mag-sign in",
  "Sign out": "Mag-sign out",
  "Signing in and making an account": "Pag-sign in at paggawa ng account",
  "Skipped (no count entered)": "Nilaktawan (walang count na nilagay)",
  "Skipped (no count):": "Nilaktawan (walang count):",
  "so you can see the full flow. Add": "para makita mo ang buong flow. Idagdag ang",
  "Something went wrong": "May nangyaring mali",
  "Source": "Source",
  "Source mapping:": "Source mapping:",
  "Special requirements": "Mga Special requirement",
  "Specification sections": "Mga Specification section",
  "STARTER estimates": "STARTER estimates",
  "Starting a new bid": "Pagsisimula ng bagong bid",
  "starts from the company": "nagsisimula sa company",
  "State": "State",
  "Status": "Status",
  "still need a device mapping.": "ang kailangan pa ng device mapping.",
  "Submit": "Isumite",
  "Success": "Tagumpay",
  "Suggested part family": "Iminungkahing part family",
  "Supplier": "Supplier",
  "Switch to": "Lumipat sa",
  "Symbol → Device → Part mapping": "Symbol → Device → Part mapping",
  "symbol image(s) attached.": "symbol image(s) ang naka-attach.",
  "symbol images cropped from page": "symbol image ang nakuha mula sa pahina",
  "symbols counted with no issues.": "symbols ang nabilang nang walang isyu.",
  "Symbols in scope": "Mga symbol na nasa scope",
  "System": "System",
  "T-drawings, e.g. 47-67": "T-drawings, hal. 47-67",
  "Tag": "Tag",
  "Takeoff basis & productivity": "Takeoff basis at productivity",
  "Teal = selected for this bid.": "Teal = napili para sa bid na ito.",
  "Telecom rooms (MDF+IDF)": "Telecom rooms (MDF+IDF)",
  "Tell me which pages to read": "Sabihin kung aling mga pahina ang babasahin",
  "That is close — losses are likely about factors other than price.": "Malapit na iyan — malamang na ang mga losses ay tungkol sa ibang factor maliban sa presyo.",
  "That suggests room to sharpen pricing on competitive work.": "Ipinapahiwatig nito na may puwang para patalasin ang pricing sa competitive na trabaho.",
  "The AI couldn’t read this document just now.": "Hindi mabasa ng AI ang dokumentong ito sa ngayon.",
  "The AI proposes a device type for each legend symbol. Confirm or override every row — this is a reliability checkpoint. ": "Nagmumungkahi ang AI ng device type para sa bawat legend symbol. Kumpirmahin o i-override ang bawat row — isa itong reliability checkpoint. ",
  "The file is read in your browser — it isn't re-uploaded for AI analysis. Needs a text layer (most modern construction PDFs have one).": "The file is read in your browser — it isn't re-uploaded for AI analysis. Needs a text layer (most modern construction PDFs have one).",
  "The folder this bid was created in — it stays here; anyone can open & work on it": "Ang folder kung saan ginawa ang bid na ito — dito ito mananatili; kahit sino puwedeng magbukas at magtrabaho dito",
  "The Phase 1 scaffold establishes the workspace, auth, roles, schema, theme and project pipeline first.": "Ang Phase 1 scaffold ang unang nag-se-set up ng workspace, auth, roles, schema, theme at project pipeline.",
  "The software never counts — every quantity is yours.": "Hindi kailanman nagbibilang ang software — sa iyo ang lahat ng quantity.",
  "The Supplier PDF lists material quantities only — no labor, pricing, markup or bid total. The internal documents are confidential.": "Ang Supplier PDF ay naglilista lamang ng material quantities — walang labor, pricing, markup o bid total. Confidential ang internal documents.",
  "The team scoreboard (Win/Loss Analytics)": "Ang scoreboard ng team (Win/Loss Analytics)",
  "The two new passwords don’t match.": "Hindi magkatugma ang dalawang bagong password.",
  "The wizard generates a complete BOM, budgetary ROM, scope letter, RFI checklist, and submittal-package outline.": "Bumubuo ang wizard ng kumpletong BOM, budgetary ROM, scope letter, RFI checklist, at submittal-package outline.",
  "This bid $/hr": "Bid na ito $/hr",
  "This bid's facility type": "This bid's facility type",
  "This only changes THIS bid — the company rate library is untouched. Re-generate the bid to apply.": "Binabago lang nito ang BID na ito — hindi nagagalaw ang company rate library. I-re-generate ang bid para mag-apply.",
  "This screen is part of the build and will be wired up in": "Bahagi ang screen na ito ng build at i-wwire up sa",
  "Title": "Pamagat",
  "to AI": "sa AI",
  "to browse.": "para mag-browse.",
  "to crop the actual glyphs from your plans' legend page and embed them in the Symbol column.": "to crop the actual glyphs from your plans' legend page and embed them in the Symbol column.",
  "to project storage…": "sa project storage…",
  "to read the entire file (only for small PDFs, <25 pages).": "para basahin ang buong file (para lang sa maliliit na PDF, <25 pahina).",
  "to read your real documents.": "para basahin ang iyong totoong mga dokumento.",
  "to see and work on the whole team's bids.": "to see and work on the whole team's bids.",
  "Tools": "Mga Tool",
  "Total": "Kabuuan",
  "Total bids": "Total na bid",
  "Total cost": "Total cost",
  "Travel & misc costs": "Travel at iba pang gastos",
  "Type": "Type",
  "uncertain": "hindi tiyak",
  "unchanged": "hindi nagbago",
  "Unit prices — adds / deducts": "Unit prices — adds / deducts",
  "Unmatched row IDs": "Hindi tugmang row IDs",
  "until you approve them above, so no one can sign in just by knowing the email domain. Their bids go in their own folder; every signed-in user can open and work on any bid. Turn OFF to stop new sign-ups.": "hanggang aprubahan mo sila sa itaas, kaya walang maka-sign in basta alam lang ang email domain. Napupunta sa sariling folder ang kanilang mga bid; bawat naka-sign in na user ay puwedeng magbukas at magtrabaho sa kahit anong bid. I-OFF para itigil ang mga bagong sign-up.",
  "Update": "I-update",
  "Update failed": "Nabigo ang update",
  "Upload": "Mag-upload",
  "Upload a document to auto-fill project information.": "Mag-upload ng dokumento para awtomatikong mapuno ang impormasyon ng proyekto.",
  "Upload a plan set above and the disciplines the AI detects will light up here — then click to choose exactly what you'll bid.": "Upload a plan set above and the disciplines the AI detects will light up here — then click to choose exactly what you'll bid.",
  "Upload price list (.xlsx)": "Mag-upload ng price list (.xlsx)",
  "Uploading": "Ina-upload ang",
  "Uploading a plan set extracts and analyzes the documents — it identifies systems, legend symbols, specs and conflicts. It never counts symbols.": "Ang pag-upload ng plan set ay kinukuha at sinusuri ang mga dokumento — tinutukoy nito ang mga system, legend symbols, specs at conflicts. Hindi ito kailanman nagbibilang ng symbols.",
  "User Guide": "Gabay sa Paggamit",
  "Users & access": "Users at access",
  "Value": "Halaga",
  "Variance": "Variance",
  "verify": "i-verify",
  "versus the winner.": "kumpara sa winner.",
  "View": "Tingnan",
  "View all bids": "Tingnan lahat ng bid",
  "vs.": "kumpara sa",
  "Wage basis:": "Wage basis:",
  "Wage rates are SAMPLE placeholders — verify against the live CA DIR / DOL determination. Material defaults to internet-estimated until distributor pricing is uploaded.": "Ang wage rates ay SAMPLE na placeholder — i-verify laban sa live na CA DIR / DOL determination. Ang material ay default na internet-estimated hangga't walang na-upload na distributor pricing.",
  "Wage type": "Wage type",
  "Wage type & county (prevailing wage / Davis-Bacon), tax, markups, margin %, and travel — then regenerate the bid.": "Wage type & county (prevailing wage / Davis-Bacon), tax, markups, margin %, at travel — pagkatapos i-regenerate ang bid.",
  "Want pictures of each symbol in the count sheet?": "Gusto mo ba ng larawan ng bawat symbol sa count sheet?",
  "warn": "babala",
  "We know the GC/owner or hold the work": "Kilala natin ang GC/owner o hawak natin ang trabaho",
  "Weighted winnability score (0–100)": "Weighted winnability score (0–100)",
  "what drove the variance — for next time": "ano ang dahilan ng variance — para sa susunod",
  "What is it?": "Ano ito?",
  "What is this program?": "Ano ang program na ito?",
  "When": "Kailan",
  "When ON, employees can self-register from the sign-in screen — but only with a": "Kapag ON, puwedeng mag-self-register ang mga empleyado mula sa sign-in screen — pero gamit lang ang",
  "where we know the winning number, we averaged": "kung saan alam natin ang winning number, nag-average tayo ng",
  "Which disciplines should I estimate?": "Aling mga discipline ang dapat kong i-estimate?",
  "who we beat / who beat us": "sino tinalo natin / sino tumalo sa atin",
  "why we passed": "bakit di natin tinuloy",
  "why we won": "bakit tayo nanalo",
  "Win rate": "Win rate",
  "Win rate by customer": "Win rate by customer",
  "Win rate by estimator": "Win rate by estimator",
  "Win/Loss Analytics": "Win/Loss Analytics",
  "Winning": "Winning",
  "Winning bid $ — who beat us (optional)": "Panalong bid $ — sino ang tumalo sa atin (opsyonal)",
  "Wipe failed": "Nabigo ang pagbura",
  "Wipe library": "Burahin ang library",
  "Wiping library…": "Binubura ang library…",
  "Won": "Won",
  "Won by": "Won by",
  "Won value": "Won value",
  "Yes": "Oo",
  "you": "ikaw",
  "You can raise any markup, but not below the company minimum (the margin floor). Sales tax can be set to the local rate. Below-default markups are reset to the minimum on save.": "Pwede mong itaas ang kahit anong markup, pero hindi sa ibaba ng company minimum (ang margin floor). Ang sales tax ay pwedeng i-set sa local rate. Ang mga markup na below-default ay ire-reset sa minimum pag-save.",
  "You can still pick disciplines below and proceed, or simply": "Maaari ka pa ring pumili ng disciplines sa ibaba at magpatuloy, o",
  "Your estimate, proposal PDFs, supplier RFQ and internal BOM. Internal documents are never sent to customers.": "Ang iyong estimate, proposal PDFs, supplier RFQ at internal BOM. Ang internal documents ay hindi kailanman ipinapadala sa mga customer.",
  "Your finished papers": "Ang iyong mga tapos na papel",
  "Your home screen and folders": "Ang iyong home screen at mga folder"
};
